/*
|--------------------------------------------------------------------------
| Video: NDN
|--------------------------------------------------------------------------
*/

/**
 * NDN Video
 * @namespace
 */
__gh__webApp.video.ndn = {

	/**
	 * Initialize
	 */
	"init": function(){
		this.loadLibrary();
	},


	/**
	 * Load the NDN library
	 */
	"loadLibrary":function() {
		__gh__webApp.common.loadScript({
			"id": "_nw2e-js",
			"src": "http://launch.newsinc.com/js/embed.js"
		});
	},


	/**
	 * Get the widget id for an NDN Category
	 * Widget ID's are stored in 3rd party data
	 */
	"getWidgetID":function(category) {
		var ndnData 	= __gh__coreData["3rdPartyData"].video.ndn,
			category 	= category.toLowerCase();
		return (typeof ndnData.categoryWidgetIds[category] === 'undefined') ? "994" : ndnData.categoryWidgetIds[category];
	},


	/**
	 * Get ndn data that is needed to render a player
	 */
	"getData": function(category){
		var ndnData 	= __gh__coreData["3rdPartyData"].video.ndn;
		return {
			 "widgetID" : this.getWidgetID(category),
			 "clientID" : ndnData.clientId,
			 "client"	: ndnData.client
		};

	}
}
